<template>
  <div class="xw-price" :style="{ color }">
    <span class="symbol" :style="{ fontSize: `${symbolSize}px` }">{{
      symbol
    }}</span>
    <span
      class="integer"
      :style="{ fontSize: `${integerSize}px`, lineHeight: 1 }"
      >{{ integer }}</span
    >
    <span class="floating-point" :style="{ fontSize: `${floatingPointSize}px` }"
      >.{{ floatingPoint || 0 }}</span
    >
    <span
      class="unit"
      v-if="unit"
      :style="{ fontSize: `${floatingPointSize}px` }"
    >
      /{{ unit }}</span
    >
  </div>
</template>
<script>
export default {
  name: 'MoneyNumber',
  props: {
    value: [Number, String],
    color: String,
    size: Number,
    symbol: {
      type: String,
      default: '￥',
    },
    unit: String,
  },
  data() {
    return {
      integer: '',
      integerSize: 24,
      floatingPoint: '',
      floatingPointSize: 14,
      symbolSize: 14,
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          const numberSplit = (this.value + '').split('.')
          this.integer = numberSplit[0]
          this.floatingPoint = numberSplit[1]
        }
      },
      immediate: true,
    },
    size: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.integerSize = newValue
          this.floatingPointSize = this.symbolSize = newValue / 2
        }
      },
      immediate: true,
    },
  },
}
</script>
<style lang="stylus" scoped>
.xw-price
  font-weight bold
</style>
